import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

import 'katex/dist/katex.min.css';
import './styles/tokens.css';
import './styles/global.css';
import './styles/markdown.css';
import './styles/code.css';
import './styles/print.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('The #root element is missing from index.html.');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);